import { t } from './i18n'

export function streamingProgressCopy(args: {
  done: number
  total: number | null
  elapsedSec: number
}): { title: string; hint: string } {
  const { done, total, elapsedSec } = args
  const title =
    total != null && total > 0 && done > 0
      ? t('Перевіряю крок {done} з {total}', { done: Math.min(done, total), total })
      : total != null && total > 0
        ? t('Готую перевірку… кроків: {total}', { total })
        : t('Аналізую документ…')
  const hint =
    elapsedSec >= 8
      ? t('Уже {sec} с. Не закривайте панель — великі документи перевіряються довше.', {
          sec: elapsedSec,
        })
      : t('Не закривайте панель, поки йде перевірка.')
  return { title, hint }
}

const ASSISTANT_TITLES: Record<string, string> = {
  ask: 'Відповідаю на запитання',
  summarize_redlines: 'Підсумовую ключові правки',
  check_defined_terms: 'Перевіряю визначені терміни',
  extract_key_terms: 'Витягаю ключові умови',
  check_placeholders: 'Шукаю плейсхолдери',
  translate_redlines: 'Перекладаю правки',
}

export function assistantProgressCopy(args: {
  action: string
  elapsedSec: number
}): { title: string; hint: string } {
  const title = t(ASSISTANT_TITLES[args.action] ?? 'Готую відповідь')
  const hint =
    args.elapsedSec >= 8
      ? t('Уже {sec} с. Не закривайте панель — відповідь ще формується.', { sec: args.elapsedSec })
      : t('Готую відповідь. Не закривайте панель.')
  return { title: `${title}…`, hint }
}
